import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=2aa712dc&scoped=true&"
import script from "./form1.vue?vue&type=script&lang=js&"
export * from "./form1.vue?vue&type=script&lang=js&"
import style0 from "./form1.vue?vue&type=style&index=0&id=2aa712dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa712dc",
  null
  
)

export default component.exports